import http from '@/plugins/http'
import { createReportApi } from './reportFactory'
const adminApi = process.env.VUE_APP_ADMIN_API;

// v2 独有
export const getIndexDataV2 = (params={}) => http.fetchGet(adminApi + 'v2/common/indexData', params)

const api = createReportApi('v2/report/')
export const getReportIndexDataV2    = api.getReportIndexData
export const getRecommendCarV2       = api.getRecommendCar
export const getRankDataV2           = api.getRankData
export const getRankNodeDataV2       = api.getRankNodeData
export const getCarSummaryDataV2     = api.getCarSummaryData
export const getCarScoreV2           = api.getCarScore
export const getCarScoreInnovateV2   = api.getCarScoreInnovate
export const getTestDetailV2         = api.getTestDetail
export const getInnovateDetailV2     = api.getInnovateDetail
export const getInnovateLineDetailV2 = api.getInnovateLineDetail
export const getNodeLineDetailV2     = api.getNodeLineDetail
export const getNodeLineTwoDetailV2  = api.getNodeLineTwoDetail
export const addCompareCarV2         = api.addCompareCar
export const delCompareCarV2         = api.delCompareCar
export const getCompareCarListV2     = api.getCompareCarList
export const changeUserCarV2         = api.changeUserCar
export const searchNodeV2            = api.searchNode
export const getParentNodesV2        = api.getParentNodes
export const getNodeVideosV2         = api.getNodeVideos

const apiLegacy = createReportApi('report/')
export const getParentNodesLegacy    = apiLegacy.getParentNodes
export const getNodeVideosLegacy     = apiLegacy.getNodeVideos
export const addCollectV2            = api.addCollect
export const delCollectV2            = api.delCollect
export const getSearchModelV2        = api.getSearchModel
export const getSearchResoultV2      = api.getSearchResoult
export const getSearchCarV2          = api.getSearchCar
export const getSearchResoultCxV2    = api.getSearchResoultCx
export const getSearchContentV2      = (params={}) => http.fetchGet(adminApi + 'v2/report/search/content', params)

// v2 独有：车型库
export const getCarFilterConfigV2 = (params={}) => http.fetchGet(adminApi + 'v2/report/car/filterConfig', params)
export const getCarLibraryV2      = (params={}) => http.fetchGet(adminApi + 'v2/report/car', params)
export const getMyCarV2           = (params={}) => http.fetchPost(adminApi + 'v2/report/user/personalizationCarList', params)

// v2 独有：功能视频
export const getNodeV2       = (params={}) => http.fetchGet(adminApi + 'v2/report/car/coreScene/tree', params)
export const getNodeDetailV2 = (params={}) => http.fetchGet(adminApi + 'v2/report/car/coreScene/video', params)
export const getRelaVideoV2  = (params={}) => http.fetchGet(adminApi + 'v2/report/car/coreScene/relateVideo', params)

// v2 独有：阵营对比
export const getCampSummaryDataV2 = (params={}) => http.fetchGet(adminApi + 'v2/report/car/campDetail', params)
export const getCampScoreV2       = (params={}) => http.fetchPost(adminApi + 'v2/report/car/campNode', params)
